// ⚠️ MOCK — dados ilustrativos para validação com o cliente.
// Remover este arquivo quando as queries reais forem implementadas (ver PRD §14).
//
// Consolida Prancheta Eletrônica = Caminhões (Truck) + Serviços/Prestadores (ServiceRequest).
// As INTERFACES são o CONTRATO das futuras queries.

export interface ClipboardKpis {
    trucksInPeriod: number;         // caminhões que entraram no período
    trucksInYardNow: number;        // caminhões em pátio agora (status inspect|release)
    avgDwellMinutes: number;        // tempo médio de permanência (min) — release/finished
    scheduledProviders: number;     // prestadores agendados no período
    expiredServices: number;        // ServiceRequest.status = 'expired'
    divergentSealsOnExit: number;   // lacres divergentes registrados na liberação
}

// Gráfico 1 — Fluxo diário (LineChart, últimos 14 dias)
export interface DailyFlowRow {
    day: string;       // 'DD/MM'
    trucks: number;
    providers: number;
}

// Gráfico 2 — Caminhões por status e motivo (ColumnChart percent)
// reason: Truck.reason = delivery|shipment|both (3 valores reais, confirmado no recon).
// séries: Truck.status = inspect|release|finished ('pending' é rascunho, NÃO entra).
export interface TrucksByReasonRow {
    reason: 'delivery' | 'shipment' | 'both';
    inspect: number;
    release: number;
    finished: number;
}

// Gráfico 3 — Não-conformidades do checklist de vistoria (BarChart horizontal)
// item = descrição real do item (Cavalo/Reboque); count = ocorrências statusTruck='error'.
export interface TruckChecklistNonConformityRow {
    item: string;
    count: number;
}

// Gráfico 4 — Serviços de prestadores por status (PieChart)
// status: ServiceRequest.status = inspect|check|finished|expired.
export interface ProviderServiceStatusRow {
    status: 'inspect' | 'check' | 'finished' | 'expired';
    count: number;
}

// Gráfico 5 — Top empresas prestadoras (BarChart horizontal, full-width)
export interface TopProviderCompanyRow {
    company: string;
    visits: number;
}

// ===========================================================================

export const MOCK_KPIS: ClipboardKpis = {
    trucksInPeriod: 312,
    trucksInYardNow: 7,
    avgDwellMinutes: 168,   // 2h48
    scheduledProviders: 96,
    expiredServices: 11,
    divergentSealsOnExit: 3,
};

export const MOCK_DAILY_FLOW: DailyFlowRow[] = [
    {day: '29/06', trucks: 21, providers: 6},
    {day: '30/06', trucks: 24, providers: 7},
    {day: '01/07', trucks: 19, providers: 5},
    {day: '02/07', trucks: 27, providers: 8},
    {day: '03/07', trucks: 23, providers: 6},
    {day: '04/07', trucks: 15, providers: 4},
    {day: '05/07', trucks: 9, providers: 2},
    {day: '06/07', trucks: 12, providers: 3},
    {day: '07/07', trucks: 26, providers: 9},
    {day: '08/07', trucks: 22, providers: 7},
    {day: '09/07', trucks: 28, providers: 8},
    {day: '10/07', trucks: 24, providers: 6},
    {day: '11/07', trucks: 18, providers: 5},
    {day: '12/07', trucks: 20, providers: 7},
];

export const MOCK_TRUCKS_BY_REASON: TrucksByReasonRow[] = [
    {reason: 'delivery', inspect: 8, release: 12, finished: 96},
    {reason: 'shipment', inspect: 5, release: 7, finished: 58},
    {reason: 'both', inspect: 3, release: 4, finished: 19},
];

export const MOCK_TRUCK_CHECKLIST_NC: TruckChecklistNonConformityRow[] = [
    {item: 'Lacre/Portas externas (Reboque)', count: 14},
    {item: 'Pneus (Reboque)', count: 11},
    {item: 'Tanque de combustível (Cavalo)', count: 9},
    {item: 'Carimbo IPPC (Reboque)', count: 8},
    {item: 'Paredes laterais (Reboque)', count: 7},
    {item: 'Cabine/áreas de armazenamento (Cavalo)', count: 6},
    {item: 'Estribo (Cavalo)', count: 5},
    {item: 'Motor (Cavalo)', count: 4},
];

export const MOCK_PROVIDER_SERVICE_STATUS: ProviderServiceStatusRow[] = [
    {status: 'inspect', count: 21},
    {status: 'check', count: 17},
    {status: 'finished', count: 47},
    {status: 'expired', count: 11},
];

export const MOCK_TOP_PROVIDER_COMPANIES: TopProviderCompanyRow[] = [
    {company: 'LogTrans Transportes', visits: 38},
    {company: 'Rodofrete Cargas', visits: 31},
    {company: 'Expressa Log', visits: 27},
    {company: 'Via Norte Transportes', visits: 22},
    {company: 'Cargas Sul', visits: 18},
    {company: 'TransPrima', visits: 15},
];
